<!--content-->
<mat-dialog-content>
	<div class="image-wrapper">
		<img src="{{imageData}}" alt="modal image" />
	</div>
	<button type="button" mat-dialog-close mat-icon-button class="close-dialog-button" matTooltip="Chiudi">
		<mat-icon>clear</mat-icon>
	</button>
</mat-dialog-content>